import { useState } from 'react'
import { useNavigate, useLocation, useOutletContext } from 'react-router-dom'
import { nextPage } from 'components/RCPro/helpers/nav'
import reactStringReplace from 'react-string-replace'
import Edit from 'components/assets/icons/Edit'
import Eye from 'components/assets/icons/Eye'
import Checkbox from 'components/common/Checkbox/Checkbox'
import Arrow from 'components/assets/icons/Arrow'
import Button from 'components/common/Button/Button'
import style from './Resume.module.scss'
import Link from 'components/common/Link/Link'
import { formatNb } from 'functions'

const RCProResume = () => {
  const navigate = useNavigate()
  const { state, pathname } = useLocation()
  const { nextPageTransition } = useOutletContext()
  const [ areTermsAccepted, setAreTermsAccepted ] = useState(state.areTermsAccepted || false)
  const { resume, estimate, signature, layout } = state.texts
  const codeProduct = resume?.exclusion?.find( codeProduct => codeProduct.name === state.codeProduct )
  const list = codeProduct?.specificExclusion || []
  const { ipid, ni } = codeProduct || {}
  const [ confirmActivity, setConfirmActivity ] = useState(!!list.length ? state.confirmActivity || false : true)
  const project = pathname.split('/')[1]

  const getPrice = () => {
    return formatNb(
      Number
      .parseFloat(state.price * (state.annual ? 12 : 1))
      .toFixed(2)
      .replace('.',',')
    ) + (
      state.annual
        ? ' €/an'
        : ' €/mois'
    )
  }

  const links = [
    {
      text: signature?.link1,
      url: ni
    },
    {},
    {
      text: signature?.link2,
      url: ipid
    }
  ]

  const BulletDot = () => (
    <svg viewBox="0 0 10 10" xmlns="http://www.w3.org/2000/svg">
      <circle fill="#272d64" cx="5" cy="5" r="3.9"/>
    </svg>
  )

  const BulletArrow = () => (
    <svg viewBox="0 0 10 10" xmlns="http://www.w3.org/2000/svg">
      <polygon fill="#272d64" points="0 0 0 10 10 5 0 0"/>
    </svg>
  )

  const end = new Date(state.activation)
  end.setFullYear( end.getFullYear() + 1 )
  end.setDate( end.getDate() - 1 )
  const dateToString = (date) => {
    const day = ('0'+date.getDate()).slice(-2)
    const month = ('0'+Number(date.getMonth() + 1)).slice(-2)
    const year = date.getFullYear()
    return `${day}/${month}/${year}`
  }

  const submit = () => {
    nextPage({ pathname, state, navigate, data: { confirmActivity, areTermsAccepted } })
    nextPageTransition()
  }

  const backToEstimate = () => {
    localStorage.setItem(project === 'rc-pro' ? 'RCPro' : project, JSON.stringify({ page: 'estimate', savedState: state }))
    nextPageTransition()
    setTimeout( () => {
      navigate('../estimate', { state })
    }, 250)
  }

  return (
    <>
      <h1>{resume?.title}</h1>

      <div className={style.bloc}>
        <Edit className={style.edit} onClick={backToEstimate} />
        <h2>{resume?.insured}</h2>
        {state.firstname} {state.lastname}
        <br/>SIRET : {state.companyImmatriculation}
        <br/>{state.activity} à {state.headquarterCity} {state.headquarterZipcode && '('+state.headquarterZipcode+')'}
        <br/>{resume?.turnover} {formatNb(state.turnover)} €
        <br/>{resume?.end} {dateToString(end)}
      </div>

      <div className={style.bloc}>
        <h2>{resume?.documents}</h2>
        <ul className={style.documents}>
          <li>
            {estimate?.notice}
            <Link
              label={<><Eye />{resume?.read}</>}
              target='_blank'
              to={ni}
            />
          </li>
          <li>
            {estimate?.fiche}
            <Link
              label={<><Eye />{resume?.read}</>}
              target='_blank'
              to={ipid}
            />
          </li>
        </ul>
      </div>

      <div className={style.bloc}>
        <Edit className={style.edit} onClick={() => navigate('../activation', { state })} />
        <h2>{resume?.activation}</h2>
        {dateToString(new Date(state.activation))}
      </div>

      <div className={style.bloc}>
        <Edit className={style.edit} onClick={() => navigate('../frequency', { state })} />
        <h2>{resume?.levy}</h2>
        {getPrice()}
      </div>

      <Checkbox
        id="agree"
        className={style.checkbox}
        checked={areTermsAccepted}
        label={
          reactStringReplace(resume?.legalterms, '{{link}}', (match, i) => (
            <Link
              key={`link-${i}`}
              label={links[i-1]?.text}
              target='_blank'
              to={links[i-1]?.url}
            />
          ))
        }
        onChange={() => setAreTermsAccepted(!areTermsAccepted)}
      />

      {!!list.length && <Checkbox
        id="confirm"
        className={style.checkbox}
        checked={confirmActivity}
        label={
          <>
            {resume?.notConcerned}
            <ul className={style.restrictions}>
              {list.map( (elm, id) => (
                <li key={`elm${id}`}>
                  <BulletDot />
                  <div>
                    {elm.name}
                    {!!elm.specificDetailExclusions?.length &&
                      <ul>
                        {
                          elm.specificDetailExclusions.map( (elm2, id2) => (
                            <li key={`elm2${id2}`}>
                              <BulletArrow /> <div>{elm2.name}</div>
                            </li>
                          ))
                        }
                      </ul>
                    }
                  </div>
                </li>
              ))}
            </ul>
          </>
        }
        onChange={() => setConfirmActivity(!confirmActivity)}
      />}

      <Button
        label={<>{layout?.next} <Arrow /></>}
        onClick={submit}
        disabled={!areTermsAccepted || !confirmActivity}
        type="primary"
      />
    </>
  )
}

export default RCProResume